import { useNavigate } from "react-router-dom";
import { updateLicencePurchase } from "../../../../api/controllers/userController";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {  useContext, useEffect, useState } from "react";
import { GlobalLoaders } from "../../../loaders/globalLoader";
import { HttpStatusCode } from "axios";
import { theme } from "../../../../styles/theme";
import { ApplicationContext } from "../../../../context/application_ctx";

export default function PurchaseReview() {
  const navigate = useNavigate();
  const {setActiveTab} = useContext(ApplicationContext)
  let batchId = window.location.search.split("batchId=");
  console.log(batchId);
  const [loaderState, setLoaderState] = useState(true);
  const [payment, setPayment] = useState(false);
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    setCounter(counter + 1);
    if (counter === 1) {
      const update = async () => {
        console.log("under");
        setLoaderState(true);
        try {
          let response = await updateLicencePurchase(
            {
              paymentRequestedBatchId: batchId[1],
            },
            localStorage.getItem("api-token")
          );
          if (response.status === HttpStatusCode.Ok) {
            console.log(response, "respInside");
            setLoaderState(false);
            setPayment(true);
            setTimeout(() => {
              navigate("/licence");
            }, 2000);
            setTimeout(() => {
              
              setActiveTab(2)
            }, 2000);
          }
        } catch (error) {
          console.log(error);
        }
      };
      update();
    }
  }, [counter]);// eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {loaderState ? (
        <>
          <GlobalLoaders />
        </>
      ) : (
        <>
          <Box
            style={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              flexDirection: "column",
            }}
          >
            {payment ? (
              <Box
                style={{
                  width: "51%",
                  height: "38%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  flexDirection: "column",
                  border: `6px solid ${theme.col_3}`,
                  borderRadius: "30px",
                  boxShadow: `0px 4px 23px 6px ${theme.col_5}`,
                }}
              >
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems={"center"}
                >
                  <CheckCircleIcon
                    sx={{ fontSize: "100px", color: theme.col_3 }}
                  />
                  <Typography
                    sx={{
                      fontSize: "30px",
                      fontWeight: "bold",
                      color: theme.col_3,
                      textAlign: "center",
                    }}
                  >
                    Payment successful
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Redirecting you to dashboard...
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                style={{
                  width: "51%",
                  height: "38%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  flexDirection: "column",
                  border: `6px solid ${theme.col_2}`,
                  borderRadius: "30px",
                  boxShadow: `0px 4px 23px 6px ${theme.col_5}`,
                }}
              >
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems={"center"}
                >
                  <CancelIcon sx={{ fontSize: "100px", color: theme.col_2 }} />
                  <Typography
                    sx={{
                      fontSize: "30px",
                      fontWeight: "bold",
                      color: theme.col_2,
                      textAlign: "center",
                    }}
                  >
                    Payment failed
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Redirecting you to dashboard...
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </>
      )}
    </>
  );
}
